import { render, staticRenderFns } from "./modalCrearLiquidador.vue?vue&type=template&id=97293588"
import script from "./modalCrearLiquidador.vue?vue&type=script&lang=js"
export * from "./modalCrearLiquidador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports